import { render } from "./MainPage.vue?vue&type=template&id=3031eaf3"
import script from "./MainPage.vue?vue&type=script&scoped=true&lang=js"
export * from "./MainPage.vue?vue&type=script&scoped=true&lang=js"

import "./MainPage.vue?vue&type=style&index=0&id=3031eaf3&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__